// extracted by mini-css-extract-plugin
module.exports = {"cpNotice":"_2oDwi","cpCon":"_2UnCG","close":"_3r9NM","body":"_1a0Xl","link":"_29G3S"};